module.exports = __webpack_public_path__ + "static/img/Tela de contas a pagar.7cfbdce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de contas a pagar.png
// module id = adCj
// module chunks = 0